import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as fromActions from './preference.actions';
import { selectColorMode, selectLang } from './preference.slice';
import { languageChangedSuccess, setColorModeSuccess } from './preference.actions';
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { loadPersistedStateSuccess } from '~/modules/app/slice';
import { select, Store } from '@ngrx/store';
import { DateUtils } from '~/shared/utils/date.utils';

@Injectable()
export class PreferenceEffects {
  changeTranslationOnLanguageChangeInStore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPersistedStateSuccess, fromActions.changeLanguage),
      concatLatestFrom(() => this.store.pipe(select(selectLang))),
      filter(([_, language]) => !!language?.code),
      tap(([_, language]) => DateUtils.changeLocale(language.code)),
      switchMap(([_, language]) => this.translateService.use(language.code)),
      distinctUntilChanged(),
      map(() => languageChangedSuccess())
    )
  );

  setColorMode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPersistedStateSuccess, fromActions.changeColorMode),
      concatLatestFrom(() => this.store.pipe(select(selectColorMode))),
      tap(([_, colorMode]) => {
        document.documentElement.dataset.theme = colorMode;
        document.body.dataset.theme = colorMode;
      }),
      map(() => setColorModeSuccess())
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly translateService: TranslateService,
    private readonly store: Store
  ) {}
}
